import React from 'react';
import ReactDOM from 'react-dom';

import {IntlProvider} from 'react-intl';

import {RoutingProvider, RoutingDecorator} from '../util/Routing';
import {AuthProvider} from '../util/Auth';

import {createStore, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import ReduxThunk from 'redux-thunk'

import ThreadContent from '../Thread/ThreadContent';

import styles from './ThreadView.module.css';
import {PermissionProvider, PermissionRepository} from '../util/Permissions';

import init from '../../redux/init';
import reducer from '../../redux/reducer';
import {threadEventsLoad} from '../../redux/actions';

const ThreadEventsOnlyView = () => (
    <div className={styles.default}>
        <ThreadContent allowEdit={false}/>
    </div>
);

export function renderView(root, data, options) {

    let state = init(data.entity);

    const composeEnhancers =
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            }) : compose;

    const enhancer = composeEnhancers(
        applyMiddleware(ReduxThunk),
        // other store enhancers if any
    );

    const store = createStore(
        reducer,
        state,
        enhancer
    );

    if (options.pushServer) {
        const socket = io(options.pushServer);
        socket.on('communicator', function (pushData) {
            if (parseInt(pushData.threadId) === data.entity.thread.id) {
                const shownEvents = store.getState().get('shownThreadEvents');

                store.dispatch(threadEventsLoad(shownEvents.last()));
            }
        });
    }

    const permissionRepository = new PermissionRepository(options.permissions);

    ReactDOM.render(
        <IntlProvider
            locale={options.locale.replace('_', '-')}
            messages={options.messages}
        >
            <AuthProvider currentParticipant={options.currentParticipant}>
                <PermissionProvider isGranted={permissionRepository.isGranted}>
                    <RoutingProvider routing={new RoutingDecorator(Routing, options.routes)}>
                        <Provider store={store}>
                            <ThreadEventsOnlyView/>
                        </Provider>
                    </RoutingProvider>
                </PermissionProvider>
            </AuthProvider>
        </IntlProvider>,
        root,
    );
}

window.ThreadEventsOnlyView = renderView;
